import { WarrantyGraphLayout } from "@modules/cms/types/WarrantyGraphLayout";
import { GetBackgroundStyle } from "@talladega/helpers";
import { useEffect, useRef } from "react";
import { useWarrantyQuotePageContext } from "@modules/purchase/WarrantyQuotePageContext";
import WarrantyGraphChart from "./WarrantyGraphChart";
import RemainingWarranty from "./RemainingWarranty";

type Props = {
  layout: WarrantyGraphLayout;
};

const WarrantyGraph = ({ layout }: Props) => {
  const { background } = layout;

  const warrantyGraphSectionRef = useRef<HTMLDivElement>(null);

  const { defaultRates, rangedRates } = useWarrantyQuotePageContext();

  const warrantyRates = rangedRates?.data || defaultRates?.data;

  const vehicleWarranty = warrantyRates?.vehicleWarranty;
  const isVehicleWarrantyFetched = !!vehicleWarranty;

  const scrollToWarrantyComponentsSection = () => {
    warrantyGraphSectionRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleCustomEvent = () => {
      scrollToWarrantyComponentsSection();
    };
    if (warrantyGraphSectionRef) {
      window.addEventListener(
        "scrollToWarrantyGraphSection",
        handleCustomEvent
      );
    }

    return () => {
      if (warrantyGraphSectionRef) {
        window.removeEventListener(
          "scrollToWarrantyGraphSection",
          handleCustomEvent
        );
      }
    };
  }, []);

  const baseDomain = process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_DOMAIN || "";

  return vehicleWarranty ? (
    <div
      id="cms-warranty-graph-section"
      className="no-scrollbar relative overflow-visible bg-white bg-cover bg-center"
      style={GetBackgroundStyle(background, baseDomain)}
      ref={warrantyGraphSectionRef}
    >
      <div className="mx-auto min-h-[300px] max-w-page px-4 pb-6 pt-10 lg:px-5 lg:py-16">
        <div className="mx-auto py-8 text-center">
          <RemainingWarranty
            vehicleWarranty={vehicleWarranty}
            bodyClassName="font-normal"
          />
        </div>
        <div className="flex justify-center">
          <div className="w-full lg:w-5/6">
            <WarrantyGraphChart
              vehicleWarranty={vehicleWarranty}
              redraw={isVehicleWarrantyFetched}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default WarrantyGraph;
